import SelectBestAnswerNotification from './components/SelectBestAnswerNotification';

export default () => {
    app.notificationComponents.selectBestAnswer = SelectBestAnswerNotification;
};
